import React from 'react';
import styles from './slotOpenerLine.scss';

interface Props {
  style: React.CSSProperties;
  automationId: string;
  isActive?: boolean;
}

export const SlotOpenerLineSvg = ({ style, automationId, isActive }: Props) => {
  return (
    <svg
      data-aid={automationId}
      className={`${styles.slotOpenerLineV3} ${isActive ? styles.active : ''}`}
      style={style}
      viewBox="-22.5 -6 45 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="-22"
        y="-5.5"
        width="44"
        height="11"
        rx="1.8"
        transform="matrix(1 0 0 -1 0 0)"
        fill={isActive ? '#A8CAFF' : '#E7F0FF'}
      />
      <rect
        x="-22"
        y="-5.5"
        width="44"
        height="11"
        rx="1.8"
        transform="matrix(1 0 0 -1 0 0)"
        stroke={isActive ? '#A8CAFF' : '#E7F0FF'}
        strokeLinejoin="round"
      />
      <path
        d={
          isActive
            ? 'M-27 -4.5L-30 -4.5C-30.5523 -4.5 -31 -4.05229 -31 -3.5L-31 -1.5'
            : 'M-17 -4.5L-20 -4.5C-20.5523 -4.5 -21 -4.05229 -21 -3.5L-21 -1.5'
        }
      />
      <path
        d={
          isActive
            ? 'M-27 4.5L-30 4.5C-30.5523 4.5 -31 4.05229 -31 3.5L-31 1.5'
            : 'M-17 4.5L-20 4.5C-20.5523 4.5 -21 4.05229 -21 3.5L-21 1.5'
        }
      />

      <path className={styles.extraLineLeft} d="M-23 4.5H-20H-17" />

      <path d="M-13 4.5H-10H-7" />

      <path d="M-3 4.5H0H3" />
      <path d="M7 4.5H10H13" />
      <path className={styles.extraLineRight} d="M17 4.5H20H23" />
      <path className={styles.extraLineLeft} d="M-23 -4.5H-20H-17" />

      <path d="M-13 -4.5H-10H-7" />
      <path d="M-3 -4.5H0H3" />
      <path d="M7 -4.5H10H13" />

      <path className={styles.extraLineRight} d="M17 -4.5H20H23" />

      <path
        d={
          isActive
            ? 'M27 4.5H30C30.5523 4.5 31 4.05229 31 3.5V1.5'
            : 'M17 4.5H20C20.5523 4.5 21 4.05229 21 3.5V1.5'
        }
      />
      <path
        d={
          isActive
            ? 'M27 -4.5H30C30.5523 -4.5 31 -4.05228 31 -3.5V-1.5'
            : 'M17 -4.5H20C20.5523 -4.5 21 -4.05228 21 -3.5V-1.5'
        }
      />
    </svg>
  );
};
